export const mixin = {
  data: () => ({
    fieldProps: {
      hideDetails: true,
      outlined: true,
      dense: true,
      color: "primary",
    },
  }),
};
